import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';
import { tokenNotExpired } from 'angular2-jwt';
import { Location } from '@angular/common';

import { environment } from '../environments/environment';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private location: Location) {}

  canActivate() {
    const productFamily = localStorage.getItem('productFamily');

    if (productFamily != environment.productFamily) {
      localStorage.removeItem('token');
      this.router.navigateByUrl('/login');
      return false;
    }

    if (!tokenNotExpired()) {
      const p = this.location.path();
      if (p && !p.match('/login')) {
        this.router.navigate(['/login', { redirect: p }]);
      } else {
        this.router.navigateByUrl('/login');
      }
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// /builds/pentech-portal/client/src/app/auth-guard.service.ts